export default __webpack_public_path__ + "static/media/cps_logo.01812b1a.png";